export const GROUP_BY_COUNT = 8;

export const DETAILS_ALLOWED = ['Activity', 'Hotel', 'Flight', 'Ferry', 'Transfer'];

export const COMBINE_ALLOWED = ['Activity', 'Hotel', 'Flight', 'Ferry', 'Transfer'];
